import { useEffect, useState } from 'react';
import { Employee } from '../interfaces/interface';
import { EmployeeService } from '../services/EmployeeService';

/**
 * Lazy-fetch an employee record by alias. Returns null while loading or on
 * unresolved aliases (e.g. former employees, PAPI errors). Cancels in-flight
 * requests on unmount or alias change to prevent stale data leaks.
 */
export const useEmployeeByAlias = (alias: string | undefined): Employee | null => {
  const [employee, setEmployee] = useState<Employee | null>(null);

  useEffect(() => {
    if (!alias) {
      setEmployee(null);
      return;
    }
    // Reset before fetching so we never display the previous alias's employee
    // while the new request is in flight or if it fails entirely.
    setEmployee(null);
    let cancelled = false;
    EmployeeService.getEmployeeByLogin(alias)
      .then((emp) => {
        if (!cancelled) setEmployee(emp);
      })
      .catch(() => {
        /* fall back to alias-only display */
      });
    return () => {
      cancelled = true;
    };
  }, [alias]);

  return employee;
};
